import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22fc305d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "nav",
  class: "h-6 bg-opacity-80 bg-blue-500 text-white text-xs font-bold relative flex px-5 py-1"
}
const _hoisted_2 = { class: "flex-auto text-left flex gap-1.5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("R / R+ Metrics")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Contributors")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "hover:bg-blue-400 px-1",
  href: "https://github.com/bhermann/DoR"
}, "Source code", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none" }, "The Department of Reuse is a department within the ROSE initiative.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        class: "hover:bg-blue-400 px-1"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'reusemetrics' },
        class: "hover:bg-blue-400 px-1"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'contributors'},
        class: "hover:bg-blue-400 px-1"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}